import Repository from "./Repository";

export default {
  // Get All contractor Companies
  getContractorCompanies() {
    return Repository.get(`/admin/contractor_company`);
  },

  getContractorCompany(id) {
    return Repository.get(`/admin/contractor_company/${id}`);
  },

  createContractorCompany(payload) {
    return Repository.post(`/admin/contractor_company`, payload);
  },

  updateContractorCompany(payload) {
    const id = payload.id;
    delete payload.id;
    return Repository.put(`/admin/contractor_company/${id}`, payload);
  },

  deleteContractorCompany(id) {
    return Repository.delete(`/admin/contractor_company/${id}`);
  },

  getContractorsByCompany(id) {
    return Repository.get(`/admin/contractor_company/${id}/contractor`);
  },

  getCompanyContractor(payload) {
    return Repository.get(
      `/admin/contractor_company/${payload.id}/contractor/${payload.email}`
    );
  },

  updateContractor(payload) {
    const email = payload.email;
    const companyId = payload.companyId;

    delete payload.email;
    delete payload.companyId;

    return Repository.put(
      `/admin/contractor_company/${companyId}/contractor/${email}`,
      payload
    );
  },

  deleteContractor(payload) {
    return Repository.delete(
      `/admin/contractor_company/${payload.id}/contractor/${payload.email}`
    );
  },

  inviteContractor(payload) {
    const id = payload.id;
    delete payload.id;
    return Repository.post(
      `/admin/contractor_company/${id}/contractor/invite`,
      payload
    );
  }
};
